import {
  ApprovalState,
  WorkDocSection,
  User,
  UUID,
} from '@builddocs/data-management'
import { ActForm } from '@builddocs/data-management'
import {
  AOSRType,
  SecondaryActType,
  signInitAct,
  signInitSecondaryAct,
} from '@builddocs/filestore-api'
import { IFaceControlCtx } from 'libs/feature-faceid/src/lib/FaceControlContext'
import { toast } from 'react-toastify'

type InitActSigningArgs = {
  isEmbedded: boolean
  user: User
  act: AOSRType | SecondaryActType
  projectId: UUID
  contractId: UUID
  selectedWorkDocSection?: Pick<WorkDocSection, 'workDocSection'>
  refreshAct: () => void
  selectedSigners: UUID[]
  setIsLoading: (v: boolean) => void
  setIsNeedUpdate: (v: boolean) => void
  faceControl: IFaceControlCtx
}
export const initActSigning = async ({
  act,
  user,
  selectedSigners,
  setIsLoading,
  projectId,
  contractId,
  refreshAct,
  setIsNeedUpdate,
  isEmbedded,
}: InitActSigningArgs) => {
  if (act.approvalStatus === ApprovalState.APPROVED) {
    if (!user) return
    if (!selectedSigners.length) {
      toast.warning(
        'Нельзя отправить на подпись! Отметьте уполномоченных в договоре и укажите соответствующий вид работ.',
      )
      return
    }

    setIsLoading(true)
    const isAosr = act.actType === ActForm.AOSR

    try {
      if (isAosr) {
        await signInitAct({
          projectId,
          journalId: contractId,
          actId: act.id,
          isEmbedded,
        })
      } else {
        await signInitSecondaryAct({
          journalId: contractId,
          actId: act.id,
          isEmbedded,
        })
      }

      refreshAct()
      toast.success('Акт отправлен на подпись')
      setIsLoading(false)
    } catch (err: any) {
      toast.warning('Нельзя отправить на подпись!')
      toast.warning(err)
      if (err.response?.data?.statusCode === 120224) {
        setIsNeedUpdate(true)
      }
    }
  }
}
